import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_GA_SOURCE
`,
    {
        prefix: "gasource/"
    }
);
